import {
  checkNodeCondition,
  checkNodeParentCondition,
  checkSelectedNodesCondition,
} from "./nodeCondition";
import { checkTextCondition } from "./nodeCondition/checkTextCondition";

import type { InlineNodeModel } from "@/models/nodes/InlineNodeModel";
import type { NodeModel } from "@/models/nodes/types";
import type { FilterRule, NodeCondition } from "@corca/data";

type FilterNodes = {
  index?: number;
  node?: InlineNodeModel;
  selectedNodes?: NodeModel[];
  selectedRequired?: boolean;
  text?: string;
};

export function matchingNodeBefore(
  node: InlineNodeModel | null,
  index: number | undefined,
  skipCondition: NodeCondition | undefined,
  skipNodes: NodeModel[] = [],
) {
  if (index == null || !node) return null;

  for (let i = index - 1; i >= 0; i--) {
    if (!skipNodes.includes(node.nodes[i])) {
      if (!skipCondition || !checkNodeCondition(skipCondition, node.nodes[i])) {
        return node.nodes[i];
      }
    }
  }

  return null;
}

export function matchingNodeAfter(
  node: InlineNodeModel | null,
  index: number | undefined,
  skipCondition: NodeCondition | undefined,
  skipNodes: NodeModel[] = [],
) {
  if (index == null || !node) return null;

  for (let i = index; i < node.nodes.length; i++) {
    if (!skipNodes.includes(node.nodes[i])) {
      if (!skipCondition || !checkNodeCondition(skipCondition, node.nodes[i])) {
        return node.nodes[i];
      }
    }
  }

  return null;
}

export function checkFilterRules(
  filterRules: FilterRule[],
  { index, node, selectedNodes, selectedRequired, text }: FilterNodes,
) {
  const startIndex = selectedNodes && selectedNodes.length > 0 ? selectedNodes[0].index : index;
  const endIndex =
    selectedNodes && selectedNodes.length > 0 ? selectedNodes.at(-1)!.index + 1 : index;

  for (const rule of filterRules) {
    const nextNodeBefore = node && startIndex != null ? node.nodes[startIndex - 1] : null;
    const nodeBefore = rule.condition.skipNodesBefore
      ? matchingNodeBefore(node ?? null, startIndex, rule.condition.skipNodesBefore)
      : nextNodeBefore;

    const nextNodeAfter = node && endIndex != null ? node.nodes[endIndex] : null;
    const nodeAfter = rule.condition.skipNodesAfter
      ? matchingNodeAfter(node ?? null, endIndex, rule.condition.skipNodesAfter)
      : nextNodeAfter;

    const { condition } = rule;

    if (
      checkTextCondition(condition.textPattern, node, text) &&
      checkNodeCondition(condition.nodeBefore, nodeBefore ?? undefined) &&
      checkNodeCondition(condition.nodeAfter, nodeAfter ?? undefined) &&
      checkNodeParentCondition(condition.parent, node) &&
      checkSelectedNodesCondition(
        condition.selectedNodes,
        condition.maxNodesSelected,
        selectedNodes,
        selectedRequired,
        condition.minNodesSelected,
      )
    ) {
      return true;
    }
  }
  return false;
}
